import React, { useState } from "react";
import "./InfluencerHowDesktop.css";

const InfluencerHowDesktop = ({ steps }) => {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <div className="influencerhowdesktop-row">
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                    <div
                        className="influencerhowdesktop-step-box"
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                    >
                        <div className="influencerhowdesktop-step-number">{index + 1}</div>
                        <div className="influencerhowdesktop-step-icon">
                            <div className="influencerhowdesktop-icon-box">
                                <img
                                    src={hoveredIndex === index ? step.iconHover : step.icon}
                                    alt={step.title}
                                />
                            </div>
                        </div>
                        <h3>{step.title}</h3>
                        <p>{step.text}</p>
                    </div>

                    {index < steps.length - 1 && (
                        <div className="influencerhowdesktop-connector-wrapper">
                            <div className="influencerhowdesktop-connector" />
                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default InfluencerHowDesktop;
